import { Link } from '@design-system/Link';
import { NavBar } from '@design-system/NavBar';
import { UPDATE_MEDICAL_HISTORY_PATH } from '@/constants/paths';
import { MyHealthHistoryPageStatusSection } from './MyHealthHistoryPageStatusSection';

export const MyHealthHistoryPage = () => {
  return (
    <section className="page-container page-container flex flex-col gap-12" data-testid="healthHistory-page">
      <div className="flex flex-col gap-6 md:gap-12" data-testid="healthHistory-container">
        <NavBar
          buttonLabel={
            <span className="max-md:hidden">Settings & Information</span>
          }
          data-testid="healthHistory-navbar"
        />

        <h1 className="typography-h1 text-primary" data-testid="healthHistory-title">My Health History</h1>

        <MyHealthHistoryPageStatusSection data-testid="healthHistory-statusSection" />

        <p className="text-tertiary typography-body" data-testid="healthHistory-description">
          It's important to keep Viome updated about any new health conditions
          so we can ensure your supplements are safe and right for you. Some
          ingredients can interact with medications or impact certain
          conditions, and we want to avoid any unintended effects. By sharing
          your latest health updates, we can fine-tune your recommendations to
          better support your well-being.
        </p>

        <div className="flex flex-col items-start text-tertiary typography-body" data-testid="healthHistory-updateSection">
          Have a change in your medical history?
          <Link
            variant="underline"
            className="text-tertiary"
            to={UPDATE_MEDICAL_HISTORY_PATH}
            data-testid="healthHistory-updateLink"
          >
            Let us know
          </Link>
        </div>
      </div>
    </section>
  );
};
